import type { Theme } from '@mui/material';

export const containerSx = { textAlign: 'center', mt: 'auto', p: 14, gap: 14 };
export const getStackSx = (theme: Theme) => ({
  flexDirection: 'row',
  gap: 4,
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.palette.accent, color: theme.palette.dark, px: 10, py: 6, borderRadius: 10,
});